import React from 'react';
import { layoutPolaroidsOnPages } from './polaroidLayout';

export default function PolaroidPrintSheet({ items, size }) {
  if (!size || !items?.length) {
    return null;
  }

  const { pages } = layoutPolaroidsOnPages(items.length, size.width_mm, size.height_mm);

  return (
    <div className="polc-print-root">
      {pages.map((page) => (
        <div key={page.pageIndex} className="polc-print-sheet">
          {page.slots.map((slot) => {
            const item = items[slot.itemIndex];
            if (!item?.dataUrl) return null;
            return (
              <div
                key={slot.itemIndex}
                className="polc-print-slot"
                style={{
                  left: `${slot.leftMm}mm`,
                  top: `${slot.topMm}mm`,
                  width: `${slot.widthMm}mm`,
                  height: `${slot.heightMm}mm`,
                }}
              >
                <img src={item.dataUrl} alt="" className="polc-print-slot__img" />
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}
